import React, { useEffect, useState } from "react";
import Popup from "../ui/Popup";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";
import { kbdEvent } from "../utils/Utils";

export default function Bindings(props) {

    const { controller = "", callback = () => { }, value = "", route = "" } = props;
    const [data, setData] = useState([])
    const [selected, setSelected] = useState("");


    useEffect(() => {
        pubCall("binding.getAll", {}, (_s, _r) => {
            if (_s) {
                let _f = _r.find(item => item.binding === value);
                if (_f) { setSelected(_f) } else { setSelected(_r[0])}
                
                setData(_r);

            } else {
                showError(_r);
            }
        })

    }, [])


    



    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { callback(selected?.binding) } }
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
        return cleanup;
    }, [actions])


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const nextIndex = data.findIndex(item => item?.binding === selected?.binding) + _rows;
        if (data.length <= nextIndex) { setSelected(data[0]);}
        if (nextIndex < data.length) { setSelected(data[nextIndex]);}
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.binding === selected?.binding) - _rows;
        if (prevIndex < 0) { setSelected(data[data.length - 1]); return;}
        if (prevIndex >= 0) { setSelected(data[prevIndex]);}
    };

    const columns = [
        { key: "description", align: "left", title: <>Description</>, width: 228 },
        { key: "binding", align: "center", title: <>Binding</>, width: 50 },
    ]

    // return(<>{JSON.stringify(menu, null, 2)}</>)



    return (<>
        <Popup 
            title={"Bindings"} 
            width={"auto"} 
            callback={callback} 
            component={<VirtualTable
                controller={controller}
                row_key={"binding"}
                next={next}
                prev={prev}
                route={route}
                current={selected}
                data={data}
                width={300}
                height={388}
                offset={0}
                columns={columns}
                onRowClick={(item, event, index) => { callback(item?.binding) }}
              
            />} 
        />
    </>)
}